
    export enum EnumVisitType {
			Regular = 0,
			Initial = 1,
			Passover = 2,
			SpecialProduction = 3,
			Review = 4,
			OneTime = 5,
			Royalties = 6,
			IllegalOU = 7,
			Substitute = 8,
			Termination = 9,
			Previous = 10,
			Commission = 11,
			PrivateLabel = 12,
			Certification = 13,
    }